import { render } from "./DeleteCollection.vue?vue&type=template&id=17e20f9c"
import script from "./DeleteCollection.vue?vue&type=script&lang=js"
export * from "./DeleteCollection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ab-front-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__